import { Divider, Pagination } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserListActions } from "../../../../users/userList/model";
import { SearchByUsersDisplayLabel } from "../../DisplayLabelsClass";
import { KeyConditionActions } from "../../model";
import {
  sendUserGroupDetailsEvent,
  UserGroupDetailsAction,
} from "../../../../../components/matomoClient";

export function SearchByUsersController(setCurrentStepState, setDisplayLabels) {
  const [pageNo, setPageNo] = useState(1);
  const [userInput, setUserInput] = useState(undefined);
  const dispatch = useDispatch();
  const InitialPageNo = 1;
  const PageSize = 5;
  let options = [];
  const SystemEmployeeId = "0";

  const {
    value: { data, totalElements },
    progress,
  } = useSelector((rootState) => rootState.userList.userList);

  setOptions();

  function setOptions() {
    if (userInput && userInput.value.length >= userInput.minChars) {
      data?.forEach((user) => {
        if (restrictSystemUser()) {
          options.push({
            key: user.key,
            label: (
              <>
                <span className="dropdown-name">{user.fullName}</span>, {user.email},{" "}
                <span className="dropdown-employee-id">{user.employeeId}</span>
              </>
            ),
            value: user.fullName + "-" + user.employeeId,
          });
        }

        function restrictSystemUser() {
          return user.employeeId !== SystemEmployeeId;
        }
      });
    }
  }

  function callUserListAPI(pageNo, input) {
    dispatch(
      UserListActions.getUserList({
        page: pageNo,
        size: PageSize,
        userQuery: {
          fullName: (!input.isNumber) ? input.value : null,
          employeeId: (input.isNumber) ? input.value : null,
          status: "active"
        },
        sorter: { sortField: "", sortDirection: "" },
      })
    );
  }

  function retainInputValueOnBlur(input) {
    if (input.value.length !== 0) {
      setUserInput(input);
    } else {
      if (userInput?.value.length === 1) {
        setUserInput(input);
      }
    }
  }

  function searchUsersWithName(input) {
    retainInputValueOnBlur(input);
    if (input.value.length >= input.minChars) {
      setPageNo(InitialPageNo);
      callUserListAPI(InitialPageNo, input);
      sendUserGroupDetailsEvent(UserGroupDetailsAction.SearchMembersByName, "Add members");
    }
  }

  function renderDropdownWithPagination(menu) {
    return (
      <>
        <div className="key-condition-search-by-user-dropdown">{menu}</div>
        {totalElements > 0 && userInput && userInput.value.length >= userInput.minChars ? (
          <>
            { userInput.isNumber ? null : <Divider style={{ margin: "8px 0" }} />}
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              className="key-condition-search-by-user-dropdown"
            >
              { userInput.isNumber ? null :
                <Pagination
                  showSizeChanger={false}
                  current={pageNo}
                  pageSize={PageSize}
                  total={totalElements}
                  onChange={(page) => {
                    setPageNo(page);
                    callUserListAPI(page, userInput);
                  }}
                />
              }
            </div>
          </>
        ) : null}
      </>
    );
  }

  function onUserSelect(_selectedInputValue, option) {
    setCurrentStepState(1);
    setDisplayLabels(new SearchByUsersDisplayLabel());
    data.forEach((user) => {
      if (user.key === option.key) {
        dispatch(KeyConditionActions.setSelectedUser(user));
      }
    });
  }

  return {
    searchUsersWithName,
    renderDropdownWithPagination,
    userInput,
    options,
    progress,
    onUserSelect,
  };
}
